/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Donio
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AccessDeniedExceptionResponse,
  ApiRequestValidationExceptionResponse,
  AssignGoodHabitsRequest,
  AssignGoodHabitsResponse,
  BadRequestExceptionResponse,
  CategoryDetailResponse,
  CategoryListResponse,
  CreateDonationRequest,
  CreateDonationResponse,
  DonationDetailResponse,
  DonationsListResponse,
  FaqResponse,
  GetCategoriesParams,
  GetDonationsParams,
  GetMyActiveGoodHabit200,
  GetProjectDonationsParams,
  GetProjectFaqsParams,
  GetProjectNewsParams,
  GetProjectPosterHtmlParams,
  GetProjectPosterPdfParams,
  GetProjectRewardsParams,
  GetProjectsParams,
  GetRecommendedProjectsParams,
  GetRouter200,
  GetRouterParams,
  GetSearchParams,
  GetSubprojectsParams,
  GetTopicsParams,
  InitPaymentIntentRequest,
  InitPaymentIntentResponse,
  InternalServerErrorExceptionResponse,
  NotFoundExceptionResponse,
  OrganizationDetailResponse,
  PaymentInfoResponse,
  PaymentIntentStateResponse,
  PostCreateDonationParams,
  ProjectBeneficiaryResponse,
  ProjectDetailResponse,
  ProjectDonationsListResponse,
  ProjectListResponse,
  ProjectNewsListResponse,
  ProjectPhotosResponse,
  ProjectPosterSendEmailRequest,
  ProjectPosterSendEmailResponse,
  RecommendedProjectsResponse,
  RewardsResponse,
  SearchResponse,
  SetCommentRequest,
  SetCommentResponse,
  SubprojectDetailResponse,
  SubprojectListResponse,
  SubprojectPhotosResponse,
  TopicDetailResponse,
  TopicListResponse,
  UserDetailResponse,
  UserGoodhabitsUnassignedResponse,
} from '@/src/api/models';

import { clientAuthFetcher } from '@/app/client-fetcher';
/**
 * Either `project`, `subproject` or `user` must be supplied
 */
export const getDonations = (params?: GetDonationsParams, signal?: AbortSignal) => {
  return clientAuthFetcher<DonationsListResponse>({ url: `/api/donations`, method: 'GET', params, signal });
};

export const getGetDonationsQueryKey = (params?: GetDonationsParams) => {
  return [`/api/donations`, ...(params ? [params] : [])] as const;
};

export const getGetDonationsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getDonations>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetDonationsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonations>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDonationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDonations>>> = ({ signal }) => getDonations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getDonations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDonationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDonations>>>;
export type GetDonationsInfiniteQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetDonationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonations>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: undefined | GetDonationsParams,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonations>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonations>>,
          TError,
          Awaited<ReturnType<typeof getDonations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonations>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetDonationsParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonations>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonations>>,
          TError,
          Awaited<ReturnType<typeof getDonations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonations>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetDonationsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonations>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetDonationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonations>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetDonationsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonations>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDonationsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetDonationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDonations>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetDonationsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonations>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDonationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDonations>>> = ({ signal }) => getDonations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDonations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDonationsQueryResult = NonNullable<Awaited<ReturnType<typeof getDonations>>>;
export type GetDonationsQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetDonations<
  TData = Awaited<ReturnType<typeof getDonations>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: undefined | GetDonationsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonations>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonations>>,
          TError,
          Awaited<ReturnType<typeof getDonations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonations<
  TData = Awaited<ReturnType<typeof getDonations>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetDonationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonations>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonations>>,
          TError,
          Awaited<ReturnType<typeof getDonations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonations<
  TData = Awaited<ReturnType<typeof getDonations>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetDonationsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonations>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetDonations<
  TData = Awaited<ReturnType<typeof getDonations>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetDonationsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonations>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDonationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create new donation (submit checkout form)
 */
export const postCreateDonation = (
  createDonationRequest: CreateDonationRequest,
  params?: PostCreateDonationParams,
  signal?: AbortSignal,
) => {
  return clientAuthFetcher<CreateDonationResponse | void>({
    url: `/api/donations`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createDonationRequest,
    params,
    signal,
  });
};

export const getPostCreateDonationMutationOptions = <
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCreateDonation>>,
    TError,
    { data: CreateDonationRequest; params?: PostCreateDonationParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCreateDonation>>,
  TError,
  { data: CreateDonationRequest; params?: PostCreateDonationParams },
  TContext
> => {
  const mutationKey = ['postCreateDonation'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCreateDonation>>,
    { data: CreateDonationRequest; params?: PostCreateDonationParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postCreateDonation(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCreateDonationMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateDonation>>>;
export type PostCreateDonationMutationBody = CreateDonationRequest;
export type PostCreateDonationMutationError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

/**
 * @summary Create new donation (submit checkout form)
 */
export const usePostCreateDonation = <
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCreateDonation>>,
      TError,
      { data: CreateDonationRequest; params?: PostCreateDonationParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCreateDonation>>,
  TError,
  { data: CreateDonationRequest; params?: PostCreateDonationParams },
  TContext
> => {
  const mutationOptions = getPostCreateDonationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const getDonationById = (id: string, signal?: AbortSignal) => {
  return clientAuthFetcher<DonationDetailResponse>({ url: `/api/donations/${id}`, method: 'GET', signal });
};

export const getGetDonationByIdQueryKey = (id: string) => {
  return [`/api/donations/${id}`] as const;
};

export const getGetDonationByIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationById>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDonationByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDonationById>>> = ({ signal }) =>
    getDonationById(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getDonationById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDonationByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDonationById>>>;
export type GetDonationByIdInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetDonationByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonationById>>,
          TError,
          Awaited<ReturnType<typeof getDonationById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonationByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonationById>>,
          TError,
          Awaited<ReturnType<typeof getDonationById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonationByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetDonationByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDonationByIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetDonationByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getDonationById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationById>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDonationByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDonationById>>> = ({ signal }) =>
    getDonationById(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDonationById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDonationByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDonationById>>>;
export type GetDonationByIdQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetDonationById<
  TData = Awaited<ReturnType<typeof getDonationById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonationById>>,
          TError,
          Awaited<ReturnType<typeof getDonationById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonationById<
  TData = Awaited<ReturnType<typeof getDonationById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonationById>>,
          TError,
          Awaited<ReturnType<typeof getDonationById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonationById<
  TData = Awaited<ReturnType<typeof getDonationById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetDonationById<
  TData = Awaited<ReturnType<typeof getDonationById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDonationByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDonationByPublicId = (publicId: string, signal?: AbortSignal) => {
  return clientAuthFetcher<DonationDetailResponse>({
    url: `/api/donations/public-id/${publicId}`,
    method: 'GET',
    signal,
  });
};

export const getGetDonationByPublicIdQueryKey = (publicId: string) => {
  return [`/api/donations/public-id/${publicId}`] as const;
};

export const getGetDonationByPublicIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationByPublicId>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationByPublicId>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDonationByPublicIdQueryKey(publicId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDonationByPublicId>>> = ({ signal }) =>
    getDonationByPublicId(publicId, signal);

  return { queryKey, queryFn, enabled: !!publicId, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getDonationByPublicId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDonationByPublicIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDonationByPublicId>>>;
export type GetDonationByPublicIdInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetDonationByPublicIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationByPublicId>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationByPublicId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonationByPublicId>>,
          TError,
          Awaited<ReturnType<typeof getDonationByPublicId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonationByPublicIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationByPublicId>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationByPublicId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonationByPublicId>>,
          TError,
          Awaited<ReturnType<typeof getDonationByPublicId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonationByPublicIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationByPublicId>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationByPublicId>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetDonationByPublicIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationByPublicId>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationByPublicId>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDonationByPublicIdInfiniteQueryOptions(publicId, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetDonationByPublicIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getDonationByPublicId>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationByPublicId>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDonationByPublicIdQueryKey(publicId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDonationByPublicId>>> = ({ signal }) =>
    getDonationByPublicId(publicId, signal);

  return { queryKey, queryFn, enabled: !!publicId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDonationByPublicId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDonationByPublicIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDonationByPublicId>>>;
export type GetDonationByPublicIdQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetDonationByPublicId<
  TData = Awaited<ReturnType<typeof getDonationByPublicId>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationByPublicId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonationByPublicId>>,
          TError,
          Awaited<ReturnType<typeof getDonationByPublicId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonationByPublicId<
  TData = Awaited<ReturnType<typeof getDonationByPublicId>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationByPublicId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonationByPublicId>>,
          TError,
          Awaited<ReturnType<typeof getDonationByPublicId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonationByPublicId<
  TData = Awaited<ReturnType<typeof getDonationByPublicId>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationByPublicId>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetDonationByPublicId<
  TData = Awaited<ReturnType<typeof getDonationByPublicId>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationByPublicId>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDonationByPublicIdQueryOptions(publicId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDonationPaymentInfo = (publicId: string, signal?: AbortSignal) => {
  return clientAuthFetcher<PaymentInfoResponse>({
    url: `/api/donations/public-id/${publicId}/payment-info`,
    method: 'GET',
    signal,
  });
};

export const getGetDonationPaymentInfoQueryKey = (publicId: string) => {
  return [`/api/donations/public-id/${publicId}/payment-info`] as const;
};

export const getGetDonationPaymentInfoInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationPaymentInfo>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationPaymentInfo>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDonationPaymentInfoQueryKey(publicId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDonationPaymentInfo>>> = ({ signal }) =>
    getDonationPaymentInfo(publicId, signal);

  return { queryKey, queryFn, enabled: !!publicId, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getDonationPaymentInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDonationPaymentInfoInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDonationPaymentInfo>>>;
export type GetDonationPaymentInfoInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetDonationPaymentInfoInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationPaymentInfo>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationPaymentInfo>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonationPaymentInfo>>,
          TError,
          Awaited<ReturnType<typeof getDonationPaymentInfo>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonationPaymentInfoInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationPaymentInfo>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationPaymentInfo>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonationPaymentInfo>>,
          TError,
          Awaited<ReturnType<typeof getDonationPaymentInfo>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonationPaymentInfoInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationPaymentInfo>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationPaymentInfo>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetDonationPaymentInfoInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationPaymentInfo>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationPaymentInfo>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDonationPaymentInfoInfiniteQueryOptions(publicId, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetDonationPaymentInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getDonationPaymentInfo>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationPaymentInfo>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDonationPaymentInfoQueryKey(publicId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDonationPaymentInfo>>> = ({ signal }) =>
    getDonationPaymentInfo(publicId, signal);

  return { queryKey, queryFn, enabled: !!publicId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDonationPaymentInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDonationPaymentInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getDonationPaymentInfo>>>;
export type GetDonationPaymentInfoQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetDonationPaymentInfo<
  TData = Awaited<ReturnType<typeof getDonationPaymentInfo>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationPaymentInfo>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonationPaymentInfo>>,
          TError,
          Awaited<ReturnType<typeof getDonationPaymentInfo>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonationPaymentInfo<
  TData = Awaited<ReturnType<typeof getDonationPaymentInfo>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationPaymentInfo>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonationPaymentInfo>>,
          TError,
          Awaited<ReturnType<typeof getDonationPaymentInfo>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonationPaymentInfo<
  TData = Awaited<ReturnType<typeof getDonationPaymentInfo>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationPaymentInfo>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetDonationPaymentInfo<
  TData = Awaited<ReturnType<typeof getDonationPaymentInfo>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationPaymentInfo>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDonationPaymentInfoQueryOptions(publicId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns wire transfer payment QR code. Only works for `wire-transfer` payment type, obviously.
 */
export const getDonationPaymentWireTransferQr = (publicId: string, signal?: AbortSignal) => {
  return clientAuthFetcher<Blob>({
    url: `/api/donations/public-id/${publicId}/payment-info/wire-transfer-qr`,
    method: 'GET',
    responseType: 'blob',
    signal,
  });
};

export const getGetDonationPaymentWireTransferQrQueryKey = (publicId: string) => {
  return [`/api/donations/public-id/${publicId}/payment-info/wire-transfer-qr`] as const;
};

export const getGetDonationPaymentWireTransferQrInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDonationPaymentWireTransferQrQueryKey(publicId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>> = ({ signal }) =>
    getDonationPaymentWireTransferQr(publicId, signal);

  return { queryKey, queryFn, enabled: !!publicId, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDonationPaymentWireTransferQrInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>
>;
export type GetDonationPaymentWireTransferQrInfiniteQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetDonationPaymentWireTransferQrInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>,
          TError,
          Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonationPaymentWireTransferQrInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>,
          TError,
          Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonationPaymentWireTransferQrInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetDonationPaymentWireTransferQrInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDonationPaymentWireTransferQrInfiniteQueryOptions(publicId, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetDonationPaymentWireTransferQrQueryOptions = <
  TData = Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDonationPaymentWireTransferQrQueryKey(publicId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>> = ({ signal }) =>
    getDonationPaymentWireTransferQr(publicId, signal);

  return { queryKey, queryFn, enabled: !!publicId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDonationPaymentWireTransferQrQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>
>;
export type GetDonationPaymentWireTransferQrQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetDonationPaymentWireTransferQr<
  TData = Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>,
          TError,
          Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonationPaymentWireTransferQr<
  TData = Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>,
          TError,
          Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDonationPaymentWireTransferQr<
  TData = Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetDonationPaymentWireTransferQr<
  TData = Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  publicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDonationPaymentWireTransferQr>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDonationPaymentWireTransferQrQueryOptions(publicId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Set (add, edit, hide, remove) comment for a donation
 */
export const setDonationComment = (publicId: string, setCommentRequest: SetCommentRequest) => {
  return clientAuthFetcher<SetCommentResponse>({
    url: `/api/donations/public-id/${publicId}/comment`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: setCommentRequest,
  });
};

export const getSetDonationCommentMutationOptions = <
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setDonationComment>>,
    TError,
    { publicId: string; data: SetCommentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setDonationComment>>,
  TError,
  { publicId: string; data: SetCommentRequest },
  TContext
> => {
  const mutationKey = ['setDonationComment'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setDonationComment>>,
    { publicId: string; data: SetCommentRequest }
  > = (props) => {
    const { publicId, data } = props ?? {};

    return setDonationComment(publicId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetDonationCommentMutationResult = NonNullable<Awaited<ReturnType<typeof setDonationComment>>>;
export type SetDonationCommentMutationBody = SetCommentRequest;
export type SetDonationCommentMutationError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

/**
 * @summary Set (add, edit, hide, remove) comment for a donation
 */
export const useSetDonationComment = <
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setDonationComment>>,
      TError,
      { publicId: string; data: SetCommentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setDonationComment>>,
  TError,
  { publicId: string; data: SetCommentRequest },
  TContext
> => {
  const mutationOptions = getSetDonationCommentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Initiate new TrustPay payment intent
 */
export const postCreatePaymentIntent = (initPaymentIntentRequest: InitPaymentIntentRequest, signal?: AbortSignal) => {
  return clientAuthFetcher<InitPaymentIntentResponse>({
    url: `/api/donations/payment/trustpay/payment-intent`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: initPaymentIntentRequest,
    signal,
  });
};

export const getPostCreatePaymentIntentMutationOptions = <
  TError = BadRequestExceptionResponse | ApiRequestValidationExceptionResponse | InternalServerErrorExceptionResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCreatePaymentIntent>>,
    TError,
    { data: InitPaymentIntentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCreatePaymentIntent>>,
  TError,
  { data: InitPaymentIntentRequest },
  TContext
> => {
  const mutationKey = ['postCreatePaymentIntent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCreatePaymentIntent>>,
    { data: InitPaymentIntentRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postCreatePaymentIntent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCreatePaymentIntentMutationResult = NonNullable<Awaited<ReturnType<typeof postCreatePaymentIntent>>>;
export type PostCreatePaymentIntentMutationBody = InitPaymentIntentRequest;
export type PostCreatePaymentIntentMutationError =
  | BadRequestExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

/**
 * @summary Initiate new TrustPay payment intent
 */
export const usePostCreatePaymentIntent = <
  TError = BadRequestExceptionResponse | ApiRequestValidationExceptionResponse | InternalServerErrorExceptionResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCreatePaymentIntent>>,
      TError,
      { data: InitPaymentIntentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCreatePaymentIntent>>,
  TError,
  { data: InitPaymentIntentRequest },
  TContext
> => {
  const mutationOptions = getPostCreatePaymentIntentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Gets TrustPay payment-intent state
 */
export const getPaymentIntentState = (paymentIntentId: string, signal?: AbortSignal) => {
  return clientAuthFetcher<PaymentIntentStateResponse>({
    url: `/api/donations/payment/trustpay/payment-intent/${paymentIntentId}/state`,
    method: 'GET',
    signal,
  });
};

export const getGetPaymentIntentStateQueryKey = (paymentIntentId: string) => {
  return [`/api/donations/payment/trustpay/payment-intent/${paymentIntentId}/state`] as const;
};

export const getGetPaymentIntentStateInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getPaymentIntentState>>>,
  TError = NotFoundExceptionResponse | ApiRequestValidationExceptionResponse | InternalServerErrorExceptionResponse,
>(
  paymentIntentId: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPaymentIntentState>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPaymentIntentStateQueryKey(paymentIntentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentIntentState>>> = ({ signal }) =>
    getPaymentIntentState(paymentIntentId, signal);

  return { queryKey, queryFn, enabled: !!paymentIntentId, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getPaymentIntentState>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPaymentIntentStateInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentIntentState>>>;
export type GetPaymentIntentStateInfiniteQueryError =
  | NotFoundExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetPaymentIntentStateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getPaymentIntentState>>>,
  TError = NotFoundExceptionResponse | ApiRequestValidationExceptionResponse | InternalServerErrorExceptionResponse,
>(
  paymentIntentId: string,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPaymentIntentState>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentIntentState>>,
          TError,
          Awaited<ReturnType<typeof getPaymentIntentState>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPaymentIntentStateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getPaymentIntentState>>>,
  TError = NotFoundExceptionResponse | ApiRequestValidationExceptionResponse | InternalServerErrorExceptionResponse,
>(
  paymentIntentId: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPaymentIntentState>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentIntentState>>,
          TError,
          Awaited<ReturnType<typeof getPaymentIntentState>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPaymentIntentStateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getPaymentIntentState>>>,
  TError = NotFoundExceptionResponse | ApiRequestValidationExceptionResponse | InternalServerErrorExceptionResponse,
>(
  paymentIntentId: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPaymentIntentState>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Gets TrustPay payment-intent state
 */

export function useGetPaymentIntentStateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getPaymentIntentState>>>,
  TError = NotFoundExceptionResponse | ApiRequestValidationExceptionResponse | InternalServerErrorExceptionResponse,
>(
  paymentIntentId: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPaymentIntentState>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPaymentIntentStateInfiniteQueryOptions(paymentIntentId, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPaymentIntentStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getPaymentIntentState>>,
  TError = NotFoundExceptionResponse | ApiRequestValidationExceptionResponse | InternalServerErrorExceptionResponse,
>(
  paymentIntentId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentIntentState>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPaymentIntentStateQueryKey(paymentIntentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentIntentState>>> = ({ signal }) =>
    getPaymentIntentState(paymentIntentId, signal);

  return { queryKey, queryFn, enabled: !!paymentIntentId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPaymentIntentState>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPaymentIntentStateQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentIntentState>>>;
export type GetPaymentIntentStateQueryError =
  | NotFoundExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetPaymentIntentState<
  TData = Awaited<ReturnType<typeof getPaymentIntentState>>,
  TError = NotFoundExceptionResponse | ApiRequestValidationExceptionResponse | InternalServerErrorExceptionResponse,
>(
  paymentIntentId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentIntentState>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentIntentState>>,
          TError,
          Awaited<ReturnType<typeof getPaymentIntentState>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPaymentIntentState<
  TData = Awaited<ReturnType<typeof getPaymentIntentState>>,
  TError = NotFoundExceptionResponse | ApiRequestValidationExceptionResponse | InternalServerErrorExceptionResponse,
>(
  paymentIntentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentIntentState>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentIntentState>>,
          TError,
          Awaited<ReturnType<typeof getPaymentIntentState>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPaymentIntentState<
  TData = Awaited<ReturnType<typeof getPaymentIntentState>>,
  TError = NotFoundExceptionResponse | ApiRequestValidationExceptionResponse | InternalServerErrorExceptionResponse,
>(
  paymentIntentId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentIntentState>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Gets TrustPay payment-intent state
 */

export function useGetPaymentIntentState<
  TData = Awaited<ReturnType<typeof getPaymentIntentState>>,
  TError = NotFoundExceptionResponse | ApiRequestValidationExceptionResponse | InternalServerErrorExceptionResponse,
>(
  paymentIntentId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentIntentState>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPaymentIntentStateQueryOptions(paymentIntentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Assign your unassigned good habit donations to a project
 */
export const assignGoodHabits = (assignGoodHabitsRequest: AssignGoodHabitsRequest, signal?: AbortSignal) => {
  return clientAuthFetcher<AssignGoodHabitsResponse>({
    url: `/api/good-habits/assign`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: assignGoodHabitsRequest,
    signal,
  });
};

export const getAssignGoodHabitsMutationOptions = <
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignGoodHabits>>,
    TError,
    { data: AssignGoodHabitsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignGoodHabits>>,
  TError,
  { data: AssignGoodHabitsRequest },
  TContext
> => {
  const mutationKey = ['assignGoodHabits'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignGoodHabits>>,
    { data: AssignGoodHabitsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return assignGoodHabits(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignGoodHabitsMutationResult = NonNullable<Awaited<ReturnType<typeof assignGoodHabits>>>;
export type AssignGoodHabitsMutationBody = AssignGoodHabitsRequest;
export type AssignGoodHabitsMutationError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

/**
 * @summary Assign your unassigned good habit donations to a project
 */
export const useAssignGoodHabits = <
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof assignGoodHabits>>,
      TError,
      { data: AssignGoodHabitsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof assignGoodHabits>>,
  TError,
  { data: AssignGoodHabitsRequest },
  TContext
> => {
  const mutationOptions = getAssignGoodHabitsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const getMyActiveGoodHabit = (signal?: AbortSignal) => {
  return clientAuthFetcher<GetMyActiveGoodHabit200>({ url: `/apijs/me/goodhabits/active`, method: 'GET', signal });
};

export const getGetMyActiveGoodHabitQueryKey = () => {
  return [`/apijs/me/goodhabits/active`] as const;
};

export const getGetMyActiveGoodHabitInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMyActiveGoodHabit>>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(options?: {
  query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyActiveGoodHabit>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyActiveGoodHabitQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyActiveGoodHabit>>> = ({ signal }) =>
    getMyActiveGoodHabit(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMyActiveGoodHabit>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyActiveGoodHabitInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMyActiveGoodHabit>>>;
export type GetMyActiveGoodHabitInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetMyActiveGoodHabitInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMyActiveGoodHabit>>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyActiveGoodHabit>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyActiveGoodHabit>>,
          TError,
          Awaited<ReturnType<typeof getMyActiveGoodHabit>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyActiveGoodHabitInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMyActiveGoodHabit>>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyActiveGoodHabit>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyActiveGoodHabit>>,
          TError,
          Awaited<ReturnType<typeof getMyActiveGoodHabit>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyActiveGoodHabitInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMyActiveGoodHabit>>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyActiveGoodHabit>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMyActiveGoodHabitInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMyActiveGoodHabit>>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyActiveGoodHabit>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyActiveGoodHabitInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMyActiveGoodHabitQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyActiveGoodHabit>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyActiveGoodHabit>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyActiveGoodHabitQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyActiveGoodHabit>>> = ({ signal }) =>
    getMyActiveGoodHabit(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyActiveGoodHabit>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyActiveGoodHabitQueryResult = NonNullable<Awaited<ReturnType<typeof getMyActiveGoodHabit>>>;
export type GetMyActiveGoodHabitQueryError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse;

export function useGetMyActiveGoodHabit<
  TData = Awaited<ReturnType<typeof getMyActiveGoodHabit>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyActiveGoodHabit>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyActiveGoodHabit>>,
          TError,
          Awaited<ReturnType<typeof getMyActiveGoodHabit>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyActiveGoodHabit<
  TData = Awaited<ReturnType<typeof getMyActiveGoodHabit>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyActiveGoodHabit>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyActiveGoodHabit>>,
          TError,
          Awaited<ReturnType<typeof getMyActiveGoodHabit>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyActiveGoodHabit<
  TData = Awaited<ReturnType<typeof getMyActiveGoodHabit>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyActiveGoodHabit>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMyActiveGoodHabit<
  TData = Awaited<ReturnType<typeof getMyActiveGoodHabit>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyActiveGoodHabit>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyActiveGoodHabitQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List of user's unassigned goodhabits
 */
export const getMyUnassignedGoodhabits = (signal?: AbortSignal) => {
  return clientAuthFetcher<UserGoodhabitsUnassignedResponse>({
    url: `/apijs/me/goodhabits/unassigned`,
    method: 'GET',
    signal,
  });
};

export const getGetMyUnassignedGoodhabitsQueryKey = () => {
  return [`/apijs/me/goodhabits/unassigned`] as const;
};

export const getGetMyUnassignedGoodhabitsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(options?: {
  query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyUnassignedGoodhabitsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>> = ({ signal }) =>
    getMyUnassignedGoodhabits(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyUnassignedGoodhabitsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>
>;
export type GetMyUnassignedGoodhabitsInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetMyUnassignedGoodhabitsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>,
          TError,
          Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyUnassignedGoodhabitsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>,
          TError,
          Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyUnassignedGoodhabitsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List of user's unassigned goodhabits
 */

export function useGetMyUnassignedGoodhabitsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyUnassignedGoodhabitsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMyUnassignedGoodhabitsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyUnassignedGoodhabitsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>> = ({ signal }) =>
    getMyUnassignedGoodhabits(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyUnassignedGoodhabitsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>>;
export type GetMyUnassignedGoodhabitsQueryError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse;

export function useGetMyUnassignedGoodhabits<
  TData = Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>,
          TError,
          Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyUnassignedGoodhabits<
  TData = Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>,
          TError,
          Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyUnassignedGoodhabits<
  TData = Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List of user's unassigned goodhabits
 */

export function useGetMyUnassignedGoodhabits<
  TData = Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyUnassignedGoodhabits>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyUnassignedGoodhabitsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * At the moment, this particular route is outside REST API namespace.
It is stateful and uses session cookie (`PHPSESSID`).
Response may contain `Set-Cookie` header with new `PHPSESSID`.
Once JWT is implemented, this route should be part of `/api/` namespace and rely on JWT, rather than on session.
 * @summary Info about current user
 */
export const getMe = (signal?: AbortSignal) => {
  return clientAuthFetcher<UserDetailResponse>({ url: `/apijs/me`, method: 'GET', signal });
};

export const getGetMeQueryKey = () => {
  return [`/apijs/me`] as const;
};

export const getGetMeInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMe>>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(options?: {
  query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeInfiniteQueryError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse;

export function useGetMeInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMe>>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getMe>>, TError, Awaited<ReturnType<typeof getMe>>>,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMe>>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getMe>>, TError, Awaited<ReturnType<typeof getMe>>>,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMe>>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Info about current user
 */

export function useGetMeInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMe>>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMeInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse;

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getMe>>, TError, Awaited<ReturnType<typeof getMe>>>,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getMe>>, TError, Awaited<ReturnType<typeof getMe>>>,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Info about current user
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getOrganizationById = (id: string, signal?: AbortSignal) => {
  return clientAuthFetcher<OrganizationDetailResponse>({ url: `/api/organizations/${id}`, method: 'GET', signal });
};

export const getGetOrganizationByIdQueryKey = (id: string) => {
  return [`/api/organizations/${id}`] as const;
};

export const getGetOrganizationByIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationById>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationById>>> = ({ signal }) =>
    getOrganizationById(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationById>>>;
export type GetOrganizationByIdInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetOrganizationByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationById>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationById>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationById>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetOrganizationByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationById>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationByIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationById>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationById>>> = ({ signal }) =>
    getOrganizationById(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationById>>>;
export type GetOrganizationByIdQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetOrganizationById<
  TData = Awaited<ReturnType<typeof getOrganizationById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationById>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationById<
  TData = Awaited<ReturnType<typeof getOrganizationById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationById>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationById<
  TData = Awaited<ReturnType<typeof getOrganizationById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetOrganizationById<
  TData = Awaited<ReturnType<typeof getOrganizationById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getOrganizationBySlug = (slug: string, signal?: AbortSignal) => {
  return clientAuthFetcher<OrganizationDetailResponse>({
    url: `/api/organizations/slug/${slug}`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationBySlugQueryKey = (slug: string) => {
  return [`/api/organizations/slug/${slug}`] as const;
};

export const getGetOrganizationBySlugInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationBySlug>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationBySlugQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationBySlug>>> = ({ signal }) =>
    getOrganizationBySlug(slug, signal);

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getOrganizationBySlug>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationBySlugInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationBySlug>>>;
export type GetOrganizationBySlugInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetOrganizationBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationBySlug>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationBySlug>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationBySlug>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationBySlug>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationBySlug>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetOrganizationBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getOrganizationBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrganizationBySlug>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationBySlugInfiniteQueryOptions(slug, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOrganizationBySlugQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBySlug>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationBySlugQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationBySlug>>> = ({ signal }) =>
    getOrganizationBySlug(slug, signal);

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationBySlug>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationBySlugQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationBySlug>>>;
export type GetOrganizationBySlugQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetOrganizationBySlug<
  TData = Awaited<ReturnType<typeof getOrganizationBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBySlug>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationBySlug>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationBySlug<
  TData = Awaited<ReturnType<typeof getOrganizationBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBySlug>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationBySlug>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationBySlug<
  TData = Awaited<ReturnType<typeof getOrganizationBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBySlug>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetOrganizationBySlug<
  TData = Awaited<ReturnType<typeof getOrganizationBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBySlug>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationBySlugQueryOptions(slug, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getProjectFaqs = (params: GetProjectFaqsParams, signal?: AbortSignal) => {
  return clientAuthFetcher<FaqResponse>({ url: `/api/project-faqs`, method: 'GET', params, signal });
};

export const getGetProjectFaqsQueryKey = (params: GetProjectFaqsParams) => {
  return [`/api/project-faqs`, ...(params ? [params] : [])] as const;
};

export const getGetProjectFaqsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectFaqs>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetProjectFaqsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectFaqs>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectFaqsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectFaqs>>> = ({ signal }) =>
    getProjectFaqs(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getProjectFaqs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectFaqsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectFaqs>>>;
export type GetProjectFaqsInfiniteQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectFaqsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectFaqs>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetProjectFaqsParams,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectFaqs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectFaqs>>,
          TError,
          Awaited<ReturnType<typeof getProjectFaqs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectFaqsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectFaqs>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetProjectFaqsParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectFaqs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectFaqs>>,
          TError,
          Awaited<ReturnType<typeof getProjectFaqs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectFaqsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectFaqs>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetProjectFaqsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectFaqs>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProjectFaqsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectFaqs>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetProjectFaqsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectFaqs>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectFaqsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetProjectFaqsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectFaqs>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetProjectFaqsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectFaqs>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectFaqsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectFaqs>>> = ({ signal }) =>
    getProjectFaqs(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectFaqs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectFaqsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectFaqs>>>;
export type GetProjectFaqsQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectFaqs<
  TData = Awaited<ReturnType<typeof getProjectFaqs>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetProjectFaqsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectFaqs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectFaqs>>,
          TError,
          Awaited<ReturnType<typeof getProjectFaqs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectFaqs<
  TData = Awaited<ReturnType<typeof getProjectFaqs>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetProjectFaqsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectFaqs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectFaqs>>,
          TError,
          Awaited<ReturnType<typeof getProjectFaqs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectFaqs<
  TData = Awaited<ReturnType<typeof getProjectFaqs>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetProjectFaqsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectFaqs>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProjectFaqs<
  TData = Awaited<ReturnType<typeof getProjectFaqs>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetProjectFaqsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectFaqs>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectFaqsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getProjectNews = (params?: GetProjectNewsParams, signal?: AbortSignal) => {
  return clientAuthFetcher<ProjectNewsListResponse>({ url: `/api/project-news`, method: 'GET', params, signal });
};

export const getGetProjectNewsQueryKey = (params?: GetProjectNewsParams) => {
  return [`/api/project-news`, ...(params ? [params] : [])] as const;
};

export const getGetProjectNewsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectNews>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectNewsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNews>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectNewsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectNews>>> = ({ signal }) =>
    getProjectNews(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getProjectNews>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectNewsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectNews>>>;
export type GetProjectNewsInfiniteQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectNewsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectNews>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: undefined | GetProjectNewsParams,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNews>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNews>>,
          TError,
          Awaited<ReturnType<typeof getProjectNews>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectNewsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectNews>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectNewsParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNews>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNews>>,
          TError,
          Awaited<ReturnType<typeof getProjectNews>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectNewsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectNews>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectNewsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNews>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProjectNewsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectNews>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectNewsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectNews>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectNewsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetProjectNewsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectNews>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectNewsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNews>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectNewsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectNews>>> = ({ signal }) =>
    getProjectNews(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectNews>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectNewsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectNews>>>;
export type GetProjectNewsQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectNews<
  TData = Awaited<ReturnType<typeof getProjectNews>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: undefined | GetProjectNewsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNews>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNews>>,
          TError,
          Awaited<ReturnType<typeof getProjectNews>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectNews<
  TData = Awaited<ReturnType<typeof getProjectNews>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectNewsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNews>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectNews>>,
          TError,
          Awaited<ReturnType<typeof getProjectNews>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectNews<
  TData = Awaited<ReturnType<typeof getProjectNews>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectNewsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNews>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProjectNews<
  TData = Awaited<ReturnType<typeof getProjectNews>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectNewsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectNews>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectNewsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getProjectPosterHtml = (id: string, params: GetProjectPosterHtmlParams, signal?: AbortSignal) => {
  return clientAuthFetcher<string>({ url: `/api/projects/${id}/poster/html`, method: 'GET', params, signal });
};

export const getGetProjectPosterHtmlQueryKey = (id: string, params: GetProjectPosterHtmlParams) => {
  return [`/api/projects/${id}/poster/html`, ...(params ? [params] : [])] as const;
};

export const getGetProjectPosterHtmlInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectPosterHtml>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterHtmlParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPosterHtml>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectPosterHtmlQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectPosterHtml>>> = ({ signal }) =>
    getProjectPosterHtml(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getProjectPosterHtml>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectPosterHtmlInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectPosterHtml>>>;
export type GetProjectPosterHtmlInfiniteQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectPosterHtmlInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectPosterHtml>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterHtmlParams,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPosterHtml>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectPosterHtml>>,
          TError,
          Awaited<ReturnType<typeof getProjectPosterHtml>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectPosterHtmlInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectPosterHtml>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterHtmlParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPosterHtml>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectPosterHtml>>,
          TError,
          Awaited<ReturnType<typeof getProjectPosterHtml>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectPosterHtmlInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectPosterHtml>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterHtmlParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPosterHtml>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProjectPosterHtmlInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectPosterHtml>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterHtmlParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPosterHtml>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectPosterHtmlInfiniteQueryOptions(id, params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetProjectPosterHtmlQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectPosterHtml>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterHtmlParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPosterHtml>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectPosterHtmlQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectPosterHtml>>> = ({ signal }) =>
    getProjectPosterHtml(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectPosterHtml>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectPosterHtmlQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectPosterHtml>>>;
export type GetProjectPosterHtmlQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectPosterHtml<
  TData = Awaited<ReturnType<typeof getProjectPosterHtml>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterHtmlParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPosterHtml>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectPosterHtml>>,
          TError,
          Awaited<ReturnType<typeof getProjectPosterHtml>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectPosterHtml<
  TData = Awaited<ReturnType<typeof getProjectPosterHtml>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterHtmlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPosterHtml>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectPosterHtml>>,
          TError,
          Awaited<ReturnType<typeof getProjectPosterHtml>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectPosterHtml<
  TData = Awaited<ReturnType<typeof getProjectPosterHtml>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterHtmlParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPosterHtml>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProjectPosterHtml<
  TData = Awaited<ReturnType<typeof getProjectPosterHtml>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterHtmlParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPosterHtml>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectPosterHtmlQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getProjectPosterPdf = (id: string, params: GetProjectPosterPdfParams, signal?: AbortSignal) => {
  return clientAuthFetcher<Blob>({
    url: `/api/projects/${id}/poster/pdf`,
    method: 'GET',
    params,
    responseType: 'blob',
    signal,
  });
};

export const getGetProjectPosterPdfQueryKey = (id: string, params: GetProjectPosterPdfParams) => {
  return [`/api/projects/${id}/poster/pdf`, ...(params ? [params] : [])] as const;
};

export const getGetProjectPosterPdfInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectPosterPdf>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterPdfParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPosterPdf>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectPosterPdfQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectPosterPdf>>> = ({ signal }) =>
    getProjectPosterPdf(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getProjectPosterPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectPosterPdfInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectPosterPdf>>>;
export type GetProjectPosterPdfInfiniteQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectPosterPdfInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectPosterPdf>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterPdfParams,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPosterPdf>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectPosterPdf>>,
          TError,
          Awaited<ReturnType<typeof getProjectPosterPdf>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectPosterPdfInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectPosterPdf>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterPdfParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPosterPdf>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectPosterPdf>>,
          TError,
          Awaited<ReturnType<typeof getProjectPosterPdf>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectPosterPdfInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectPosterPdf>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterPdfParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPosterPdf>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProjectPosterPdfInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectPosterPdf>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterPdfParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPosterPdf>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectPosterPdfInfiniteQueryOptions(id, params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetProjectPosterPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectPosterPdf>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterPdfParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPosterPdf>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectPosterPdfQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectPosterPdf>>> = ({ signal }) =>
    getProjectPosterPdf(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectPosterPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectPosterPdfQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectPosterPdf>>>;
export type GetProjectPosterPdfQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectPosterPdf<
  TData = Awaited<ReturnType<typeof getProjectPosterPdf>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterPdfParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPosterPdf>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectPosterPdf>>,
          TError,
          Awaited<ReturnType<typeof getProjectPosterPdf>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectPosterPdf<
  TData = Awaited<ReturnType<typeof getProjectPosterPdf>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterPdfParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPosterPdf>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectPosterPdf>>,
          TError,
          Awaited<ReturnType<typeof getProjectPosterPdf>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectPosterPdf<
  TData = Awaited<ReturnType<typeof getProjectPosterPdf>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterPdfParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPosterPdf>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProjectPosterPdf<
  TData = Awaited<ReturnType<typeof getProjectPosterPdf>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: GetProjectPosterPdfParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPosterPdf>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectPosterPdfQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postSendPosterByEmail = (
  id: string,
  projectPosterSendEmailRequest: ProjectPosterSendEmailRequest,
  signal?: AbortSignal,
) => {
  return clientAuthFetcher<ProjectPosterSendEmailResponse>({
    url: `/api/projects/${id}/poster/send-email`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: projectPosterSendEmailRequest,
    signal,
  });
};

export const getPostSendPosterByEmailMutationOptions = <
  TError = BadRequestExceptionResponse | AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSendPosterByEmail>>,
    TError,
    { id: string; data: ProjectPosterSendEmailRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSendPosterByEmail>>,
  TError,
  { id: string; data: ProjectPosterSendEmailRequest },
  TContext
> => {
  const mutationKey = ['postSendPosterByEmail'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSendPosterByEmail>>,
    { id: string; data: ProjectPosterSendEmailRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return postSendPosterByEmail(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSendPosterByEmailMutationResult = NonNullable<Awaited<ReturnType<typeof postSendPosterByEmail>>>;
export type PostSendPosterByEmailMutationBody = ProjectPosterSendEmailRequest;
export type PostSendPosterByEmailMutationError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | InternalServerErrorExceptionResponse;

export const usePostSendPosterByEmail = <
  TError = BadRequestExceptionResponse | AccessDeniedExceptionResponse | InternalServerErrorExceptionResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSendPosterByEmail>>,
      TError,
      { id: string; data: ProjectPosterSendEmailRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSendPosterByEmail>>,
  TError,
  { id: string; data: ProjectPosterSendEmailRequest },
  TContext
> => {
  const mutationOptions = getPostSendPosterByEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const getProjectBeneficiary = (id: string, signal?: AbortSignal) => {
  return clientAuthFetcher<ProjectBeneficiaryResponse>({
    url: `/api/projects/${id}/beneficiary`,
    method: 'GET',
    signal,
  });
};

export const getGetProjectBeneficiaryQueryKey = (id: string) => {
  return [`/api/projects/${id}/beneficiary`] as const;
};

export const getGetProjectBeneficiaryInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectBeneficiary>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectBeneficiary>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectBeneficiaryQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectBeneficiary>>> = ({ signal }) =>
    getProjectBeneficiary(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getProjectBeneficiary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectBeneficiaryInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectBeneficiary>>>;
export type GetProjectBeneficiaryInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectBeneficiaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectBeneficiary>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectBeneficiary>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectBeneficiary>>,
          TError,
          Awaited<ReturnType<typeof getProjectBeneficiary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectBeneficiaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectBeneficiary>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectBeneficiary>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectBeneficiary>>,
          TError,
          Awaited<ReturnType<typeof getProjectBeneficiary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectBeneficiaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectBeneficiary>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectBeneficiary>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProjectBeneficiaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectBeneficiary>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectBeneficiary>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectBeneficiaryInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetProjectBeneficiaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectBeneficiary>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectBeneficiary>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectBeneficiaryQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectBeneficiary>>> = ({ signal }) =>
    getProjectBeneficiary(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectBeneficiary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectBeneficiaryQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectBeneficiary>>>;
export type GetProjectBeneficiaryQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectBeneficiary<
  TData = Awaited<ReturnType<typeof getProjectBeneficiary>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectBeneficiary>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectBeneficiary>>,
          TError,
          Awaited<ReturnType<typeof getProjectBeneficiary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectBeneficiary<
  TData = Awaited<ReturnType<typeof getProjectBeneficiary>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectBeneficiary>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectBeneficiary>>,
          TError,
          Awaited<ReturnType<typeof getProjectBeneficiary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectBeneficiary<
  TData = Awaited<ReturnType<typeof getProjectBeneficiary>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectBeneficiary>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProjectBeneficiary<
  TData = Awaited<ReturnType<typeof getProjectBeneficiary>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectBeneficiary>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectBeneficiaryQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary All base info about project
 */
export const getProjectById = (id: string, signal?: AbortSignal) => {
  return clientAuthFetcher<ProjectDetailResponse>({ url: `/api/projects/${id}`, method: 'GET', signal });
};

export const getGetProjectByIdQueryKey = (id: string) => {
  return [`/api/projects/${id}`] as const;
};

export const getGetProjectByIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectById>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectById>>> = ({ signal }) => getProjectById(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getProjectById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectById>>>;
export type GetProjectByIdInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectById>>,
          TError,
          Awaited<ReturnType<typeof getProjectById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectById>>,
          TError,
          Awaited<ReturnType<typeof getProjectById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary All base info about project
 */

export function useGetProjectByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectByIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetProjectByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectById>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectById>>> = ({ signal }) => getProjectById(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectById>>>;
export type GetProjectByIdQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectById<
  TData = Awaited<ReturnType<typeof getProjectById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectById>>,
          TError,
          Awaited<ReturnType<typeof getProjectById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectById<
  TData = Awaited<ReturnType<typeof getProjectById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectById>>,
          TError,
          Awaited<ReturnType<typeof getProjectById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectById<
  TData = Awaited<ReturnType<typeof getProjectById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary All base info about project
 */

export function useGetProjectById<
  TData = Awaited<ReturnType<typeof getProjectById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary All base info about project
 */
export const getProjectByNumericId = (numericId: number, signal?: AbortSignal) => {
  return clientAuthFetcher<ProjectDetailResponse>({
    url: `/api/projects/numeric-id/${numericId}`,
    method: 'GET',
    signal,
  });
};

export const getGetProjectByNumericIdQueryKey = (numericId: number) => {
  return [`/api/projects/numeric-id/${numericId}`] as const;
};

export const getGetProjectByNumericIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectByNumericId>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  numericId: number,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectByNumericId>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectByNumericIdQueryKey(numericId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectByNumericId>>> = ({ signal }) =>
    getProjectByNumericId(numericId, signal);

  return { queryKey, queryFn, enabled: !!numericId, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getProjectByNumericId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectByNumericIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectByNumericId>>>;
export type GetProjectByNumericIdInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectByNumericIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectByNumericId>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  numericId: number,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectByNumericId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectByNumericId>>,
          TError,
          Awaited<ReturnType<typeof getProjectByNumericId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectByNumericIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectByNumericId>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  numericId: number,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectByNumericId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectByNumericId>>,
          TError,
          Awaited<ReturnType<typeof getProjectByNumericId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectByNumericIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectByNumericId>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  numericId: number,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectByNumericId>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary All base info about project
 */

export function useGetProjectByNumericIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectByNumericId>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  numericId: number,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectByNumericId>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectByNumericIdInfiniteQueryOptions(numericId, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetProjectByNumericIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectByNumericId>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  numericId: number,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectByNumericId>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectByNumericIdQueryKey(numericId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectByNumericId>>> = ({ signal }) =>
    getProjectByNumericId(numericId, signal);

  return { queryKey, queryFn, enabled: !!numericId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectByNumericId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectByNumericIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectByNumericId>>>;
export type GetProjectByNumericIdQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectByNumericId<
  TData = Awaited<ReturnType<typeof getProjectByNumericId>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  numericId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectByNumericId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectByNumericId>>,
          TError,
          Awaited<ReturnType<typeof getProjectByNumericId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectByNumericId<
  TData = Awaited<ReturnType<typeof getProjectByNumericId>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  numericId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectByNumericId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectByNumericId>>,
          TError,
          Awaited<ReturnType<typeof getProjectByNumericId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectByNumericId<
  TData = Awaited<ReturnType<typeof getProjectByNumericId>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  numericId: number,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectByNumericId>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary All base info about project
 */

export function useGetProjectByNumericId<
  TData = Awaited<ReturnType<typeof getProjectByNumericId>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  numericId: number,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectByNumericId>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectByNumericIdQueryOptions(numericId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary All base info about project
 */
export const getProjectBySlug = (slug: string, signal?: AbortSignal) => {
  return clientAuthFetcher<ProjectDetailResponse>({ url: `/api/projects/slug/${slug}`, method: 'GET', signal });
};

export const getGetProjectBySlugQueryKey = (slug: string) => {
  return [`/api/projects/slug/${slug}`] as const;
};

export const getGetProjectBySlugInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectBySlug>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectBySlugQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectBySlug>>> = ({ signal }) =>
    getProjectBySlug(slug, signal);

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getProjectBySlug>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectBySlugInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectBySlug>>>;
export type GetProjectBySlugInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectBySlug>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectBySlug>>,
          TError,
          Awaited<ReturnType<typeof getProjectBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectBySlug>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectBySlug>>,
          TError,
          Awaited<ReturnType<typeof getProjectBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectBySlug>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary All base info about project
 */

export function useGetProjectBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectBySlug>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectBySlugInfiniteQueryOptions(slug, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetProjectBySlugQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectBySlug>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectBySlugQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectBySlug>>> = ({ signal }) =>
    getProjectBySlug(slug, signal);

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectBySlug>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectBySlugQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectBySlug>>>;
export type GetProjectBySlugQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectBySlug<
  TData = Awaited<ReturnType<typeof getProjectBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectBySlug>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectBySlug>>,
          TError,
          Awaited<ReturnType<typeof getProjectBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectBySlug<
  TData = Awaited<ReturnType<typeof getProjectBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectBySlug>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectBySlug>>,
          TError,
          Awaited<ReturnType<typeof getProjectBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectBySlug<
  TData = Awaited<ReturnType<typeof getProjectBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectBySlug>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary All base info about project
 */

export function useGetProjectBySlug<
  TData = Awaited<ReturnType<typeof getProjectBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectBySlug>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectBySlugQueryOptions(slug, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getProjectPhotos = (id: string, signal?: AbortSignal) => {
  return clientAuthFetcher<ProjectPhotosResponse>({ url: `/api/projects/${id}/photos`, method: 'GET', signal });
};

export const getGetProjectPhotosQueryKey = (id: string) => {
  return [`/api/projects/${id}/photos`] as const;
};

export const getGetProjectPhotosInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectPhotos>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPhotos>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectPhotosQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectPhotos>>> = ({ signal }) =>
    getProjectPhotos(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getProjectPhotos>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectPhotosInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectPhotos>>>;
export type GetProjectPhotosInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectPhotosInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectPhotos>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPhotos>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectPhotos>>,
          TError,
          Awaited<ReturnType<typeof getProjectPhotos>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectPhotosInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectPhotos>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPhotos>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectPhotos>>,
          TError,
          Awaited<ReturnType<typeof getProjectPhotos>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectPhotosInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectPhotos>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPhotos>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProjectPhotosInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectPhotos>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectPhotos>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectPhotosInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetProjectPhotosQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectPhotos>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPhotos>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectPhotosQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectPhotos>>> = ({ signal }) =>
    getProjectPhotos(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectPhotos>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectPhotosQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectPhotos>>>;
export type GetProjectPhotosQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectPhotos<
  TData = Awaited<ReturnType<typeof getProjectPhotos>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPhotos>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectPhotos>>,
          TError,
          Awaited<ReturnType<typeof getProjectPhotos>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectPhotos<
  TData = Awaited<ReturnType<typeof getProjectPhotos>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPhotos>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectPhotos>>,
          TError,
          Awaited<ReturnType<typeof getProjectPhotos>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectPhotos<
  TData = Awaited<ReturnType<typeof getProjectPhotos>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPhotos>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProjectPhotos<
  TData = Awaited<ReturnType<typeof getProjectPhotos>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPhotos>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectPhotosQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List of paid donations associated with the project, ordered by donation order
 */
export const getProjectDonations = (id: string, params?: GetProjectDonationsParams, signal?: AbortSignal) => {
  return clientAuthFetcher<ProjectDonationsListResponse>({
    url: `/api/projects/${id}/donations`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetProjectDonationsQueryKey = (id: string, params?: GetProjectDonationsParams) => {
  return [`/api/projects/${id}/donations`, ...(params ? [params] : [])] as const;
};

export const getGetProjectDonationsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectDonations>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params?: GetProjectDonationsParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectDonations>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectDonationsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectDonations>>> = ({ signal }) =>
    getProjectDonations(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getProjectDonations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectDonationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectDonations>>>;
export type GetProjectDonationsInfiniteQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectDonationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectDonations>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: undefined | GetProjectDonationsParams,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectDonations>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectDonations>>,
          TError,
          Awaited<ReturnType<typeof getProjectDonations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectDonationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectDonations>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params?: GetProjectDonationsParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectDonations>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectDonations>>,
          TError,
          Awaited<ReturnType<typeof getProjectDonations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectDonationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectDonations>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params?: GetProjectDonationsParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectDonations>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List of paid donations associated with the project, ordered by donation order
 */

export function useGetProjectDonationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectDonations>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params?: GetProjectDonationsParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectDonations>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectDonationsInfiniteQueryOptions(id, params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetProjectDonationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectDonations>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params?: GetProjectDonationsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectDonations>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectDonationsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectDonations>>> = ({ signal }) =>
    getProjectDonations(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectDonations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectDonationsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectDonations>>>;
export type GetProjectDonationsQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectDonations<
  TData = Awaited<ReturnType<typeof getProjectDonations>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: undefined | GetProjectDonationsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectDonations>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectDonations>>,
          TError,
          Awaited<ReturnType<typeof getProjectDonations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectDonations<
  TData = Awaited<ReturnType<typeof getProjectDonations>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params?: GetProjectDonationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectDonations>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectDonations>>,
          TError,
          Awaited<ReturnType<typeof getProjectDonations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectDonations<
  TData = Awaited<ReturnType<typeof getProjectDonations>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params?: GetProjectDonationsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectDonations>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List of paid donations associated with the project, ordered by donation order
 */

export function useGetProjectDonations<
  TData = Awaited<ReturnType<typeof getProjectDonations>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | NotFoundExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params?: GetProjectDonationsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectDonations>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectDonationsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getProjects = (params?: GetProjectsParams, signal?: AbortSignal) => {
  return clientAuthFetcher<ProjectListResponse>({ url: `/api/projects`, method: 'GET', params, signal });
};

export const getGetProjectsQueryKey = (params?: GetProjectsParams) => {
  return [`/api/projects`, ...(params ? [params] : [])] as const;
};

export const getGetProjectsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getProjects>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjects>>> = ({ signal }) => getProjects(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getProjects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjects>>>;
export type GetProjectsInfiniteQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjects>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: undefined | GetProjectsParams,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjects>>,
          TError,
          Awaited<ReturnType<typeof getProjects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjects>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectsParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjects>>,
          TError,
          Awaited<ReturnType<typeof getProjects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjects>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProjectsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjects>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetProjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjects>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjects>>> = ({ signal }) => getProjects(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjects>>>;
export type GetProjectsQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjects<
  TData = Awaited<ReturnType<typeof getProjects>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: undefined | GetProjectsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjects>>,
          TError,
          Awaited<ReturnType<typeof getProjects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjects<
  TData = Awaited<ReturnType<typeof getProjects>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjects>>,
          TError,
          Awaited<ReturnType<typeof getProjects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjects<
  TData = Awaited<ReturnType<typeof getProjects>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProjects<
  TData = Awaited<ReturnType<typeof getProjects>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecommendedProjects = (id: string, params?: GetRecommendedProjectsParams, signal?: AbortSignal) => {
  return clientAuthFetcher<RecommendedProjectsResponse>({
    url: `/api/projects/${id}/recommended`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetRecommendedProjectsQueryKey = (id: string, params?: GetRecommendedProjectsParams) => {
  return [`/api/projects/${id}/recommended`, ...(params ? [params] : [])] as const;
};

export const getGetRecommendedProjectsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getRecommendedProjects>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params?: GetRecommendedProjectsParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRecommendedProjects>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRecommendedProjectsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecommendedProjects>>> = ({ signal }) =>
    getRecommendedProjects(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getRecommendedProjects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRecommendedProjectsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getRecommendedProjects>>>;
export type GetRecommendedProjectsInfiniteQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetRecommendedProjectsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRecommendedProjects>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: undefined | GetRecommendedProjectsParams,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRecommendedProjects>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecommendedProjects>>,
          TError,
          Awaited<ReturnType<typeof getRecommendedProjects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRecommendedProjectsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRecommendedProjects>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params?: GetRecommendedProjectsParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRecommendedProjects>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecommendedProjects>>,
          TError,
          Awaited<ReturnType<typeof getRecommendedProjects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRecommendedProjectsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRecommendedProjects>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params?: GetRecommendedProjectsParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRecommendedProjects>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetRecommendedProjectsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRecommendedProjects>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params?: GetRecommendedProjectsParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRecommendedProjects>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRecommendedProjectsInfiniteQueryOptions(id, params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetRecommendedProjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecommendedProjects>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params?: GetRecommendedProjectsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecommendedProjects>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRecommendedProjectsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecommendedProjects>>> = ({ signal }) =>
    getRecommendedProjects(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecommendedProjects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRecommendedProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getRecommendedProjects>>>;
export type GetRecommendedProjectsQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetRecommendedProjects<
  TData = Awaited<ReturnType<typeof getRecommendedProjects>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params: undefined | GetRecommendedProjectsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecommendedProjects>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecommendedProjects>>,
          TError,
          Awaited<ReturnType<typeof getRecommendedProjects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRecommendedProjects<
  TData = Awaited<ReturnType<typeof getRecommendedProjects>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params?: GetRecommendedProjectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecommendedProjects>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecommendedProjects>>,
          TError,
          Awaited<ReturnType<typeof getRecommendedProjects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRecommendedProjects<
  TData = Awaited<ReturnType<typeof getRecommendedProjects>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params?: GetRecommendedProjectsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecommendedProjects>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetRecommendedProjects<
  TData = Awaited<ReturnType<typeof getRecommendedProjects>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  id: string,
  params?: GetRecommendedProjectsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecommendedProjects>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRecommendedProjectsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getProjectRewards = (params?: GetProjectRewardsParams, signal?: AbortSignal) => {
  return clientAuthFetcher<RewardsResponse>({ url: `/api/project-rewards`, method: 'GET', params, signal });
};

export const getGetProjectRewardsQueryKey = (params?: GetProjectRewardsParams) => {
  return [`/api/project-rewards`, ...(params ? [params] : [])] as const;
};

export const getGetProjectRewardsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectRewards>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectRewardsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectRewards>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectRewardsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectRewards>>> = ({ signal }) =>
    getProjectRewards(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getProjectRewards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectRewardsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectRewards>>>;
export type GetProjectRewardsInfiniteQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectRewardsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectRewards>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: undefined | GetProjectRewardsParams,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectRewards>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectRewards>>,
          TError,
          Awaited<ReturnType<typeof getProjectRewards>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectRewardsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectRewards>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectRewardsParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectRewards>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectRewards>>,
          TError,
          Awaited<ReturnType<typeof getProjectRewards>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectRewardsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectRewards>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectRewardsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectRewards>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProjectRewardsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getProjectRewards>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectRewardsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProjectRewards>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectRewardsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetProjectRewardsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectRewards>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectRewardsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectRewards>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectRewardsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectRewards>>> = ({ signal }) =>
    getProjectRewards(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectRewards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectRewardsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectRewards>>>;
export type GetProjectRewardsQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetProjectRewards<
  TData = Awaited<ReturnType<typeof getProjectRewards>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: undefined | GetProjectRewardsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectRewards>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectRewards>>,
          TError,
          Awaited<ReturnType<typeof getProjectRewards>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectRewards<
  TData = Awaited<ReturnType<typeof getProjectRewards>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectRewardsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectRewards>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectRewards>>,
          TError,
          Awaited<ReturnType<typeof getProjectRewards>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectRewards<
  TData = Awaited<ReturnType<typeof getProjectRewards>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectRewardsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectRewards>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProjectRewards<
  TData = Awaited<ReturnType<typeof getProjectRewards>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetProjectRewardsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectRewards>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectRewardsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Determine type of page based on slug
 */
export const getRouter = (params: GetRouterParams, signal?: AbortSignal) => {
  return clientAuthFetcher<GetRouter200>({ url: `/api/router`, method: 'GET', params, signal });
};

export const getGetRouterQueryKey = (params: GetRouterParams) => {
  return [`/api/router`, ...(params ? [params] : [])] as const;
};

export const getGetRouterInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getRouter>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetRouterParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRouter>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRouterQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRouter>>> = ({ signal }) => getRouter(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getRouter>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRouterInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getRouter>>>;
export type GetRouterInfiniteQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetRouterInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRouter>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetRouterParams,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRouter>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getRouter>>, TError, Awaited<ReturnType<typeof getRouter>>>,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRouterInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRouter>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetRouterParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRouter>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRouter>>,
          TError,
          Awaited<ReturnType<typeof getRouter>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRouterInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRouter>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetRouterParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRouter>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Determine type of page based on slug
 */

export function useGetRouterInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRouter>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetRouterParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRouter>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRouterInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetRouterQueryOptions = <
  TData = Awaited<ReturnType<typeof getRouter>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetRouterParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRouter>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRouterQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRouter>>> = ({ signal }) => getRouter(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRouter>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRouterQueryResult = NonNullable<Awaited<ReturnType<typeof getRouter>>>;
export type GetRouterQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetRouter<
  TData = Awaited<ReturnType<typeof getRouter>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetRouterParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRouter>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getRouter>>, TError, Awaited<ReturnType<typeof getRouter>>>,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRouter<
  TData = Awaited<ReturnType<typeof getRouter>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetRouterParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRouter>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRouter>>,
          TError,
          Awaited<ReturnType<typeof getRouter>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRouter<
  TData = Awaited<ReturnType<typeof getRouter>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetRouterParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRouter>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Determine type of page based on slug
 */

export function useGetRouter<
  TData = Awaited<ReturnType<typeof getRouter>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetRouterParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRouter>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRouterQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search in projects, categories and organizations.
 */
export const getSearch = (params: GetSearchParams, signal?: AbortSignal) => {
  return clientAuthFetcher<SearchResponse>({ url: `/api/search`, method: 'GET', params, signal });
};

export const getGetSearchQueryKey = (params: GetSearchParams) => {
  return [`/api/search`, ...(params ? [params] : [])] as const;
};

export const getGetSearchInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getSearch>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetSearchParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSearch>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearch>>> = ({ signal }) => getSearch(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSearchInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getSearch>>>;
export type GetSearchInfiniteQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetSearchInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSearch>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetSearchParams,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSearch>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getSearch>>, TError, Awaited<ReturnType<typeof getSearch>>>,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSearchInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSearch>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetSearchParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSearch>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearch>>,
          TError,
          Awaited<ReturnType<typeof getSearch>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSearchInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSearch>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetSearchParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSearch>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search in projects, categories and organizations.
 */

export function useGetSearchInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSearch>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetSearchParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSearch>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSearchInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof getSearch>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetSearchParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearch>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearch>>> = ({ signal }) => getSearch(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getSearch>>>;
export type GetSearchQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetSearch<
  TData = Awaited<ReturnType<typeof getSearch>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetSearchParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearch>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getSearch>>, TError, Awaited<ReturnType<typeof getSearch>>>,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSearch<
  TData = Awaited<ReturnType<typeof getSearch>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetSearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearch>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearch>>,
          TError,
          Awaited<ReturnType<typeof getSearch>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSearch<
  TData = Awaited<ReturnType<typeof getSearch>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetSearchParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearch>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search in projects, categories and organizations.
 */

export function useGetSearch<
  TData = Awaited<ReturnType<typeof getSearch>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: GetSearchParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearch>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSearchQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSubprojectById = (id: string, signal?: AbortSignal) => {
  return clientAuthFetcher<SubprojectDetailResponse>({ url: `/api/subprojects/${id}`, method: 'GET', signal });
};

export const getGetSubprojectByIdQueryKey = (id: string) => {
  return [`/api/subprojects/${id}`] as const;
};

export const getGetSubprojectByIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojectById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojectById>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubprojectByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubprojectById>>> = ({ signal }) =>
    getSubprojectById(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getSubprojectById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSubprojectByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getSubprojectById>>>;
export type GetSubprojectByIdInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetSubprojectByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojectById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojectById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubprojectById>>,
          TError,
          Awaited<ReturnType<typeof getSubprojectById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubprojectByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojectById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojectById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubprojectById>>,
          TError,
          Awaited<ReturnType<typeof getSubprojectById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubprojectByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojectById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojectById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSubprojectByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojectById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojectById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSubprojectByIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetSubprojectByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubprojectById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojectById>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubprojectByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubprojectById>>> = ({ signal }) =>
    getSubprojectById(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubprojectById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSubprojectByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getSubprojectById>>>;
export type GetSubprojectByIdQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetSubprojectById<
  TData = Awaited<ReturnType<typeof getSubprojectById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojectById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubprojectById>>,
          TError,
          Awaited<ReturnType<typeof getSubprojectById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubprojectById<
  TData = Awaited<ReturnType<typeof getSubprojectById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojectById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubprojectById>>,
          TError,
          Awaited<ReturnType<typeof getSubprojectById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubprojectById<
  TData = Awaited<ReturnType<typeof getSubprojectById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojectById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSubprojectById<
  TData = Awaited<ReturnType<typeof getSubprojectById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojectById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSubprojectByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSubprojectBySlug = (slug: string, signal?: AbortSignal) => {
  return clientAuthFetcher<SubprojectDetailResponse>({ url: `/api/subprojects/slug/${slug}`, method: 'GET', signal });
};

export const getGetSubprojectBySlugQueryKey = (slug: string) => {
  return [`/api/subprojects/slug/${slug}`] as const;
};

export const getGetSubprojectBySlugInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojectBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojectBySlug>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubprojectBySlugQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubprojectBySlug>>> = ({ signal }) =>
    getSubprojectBySlug(slug, signal);

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getSubprojectBySlug>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSubprojectBySlugInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getSubprojectBySlug>>>;
export type GetSubprojectBySlugInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetSubprojectBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojectBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojectBySlug>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubprojectBySlug>>,
          TError,
          Awaited<ReturnType<typeof getSubprojectBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubprojectBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojectBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojectBySlug>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubprojectBySlug>>,
          TError,
          Awaited<ReturnType<typeof getSubprojectBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubprojectBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojectBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojectBySlug>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSubprojectBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojectBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojectBySlug>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSubprojectBySlugInfiniteQueryOptions(slug, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetSubprojectBySlugQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubprojectBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojectBySlug>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubprojectBySlugQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubprojectBySlug>>> = ({ signal }) =>
    getSubprojectBySlug(slug, signal);

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubprojectBySlug>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSubprojectBySlugQueryResult = NonNullable<Awaited<ReturnType<typeof getSubprojectBySlug>>>;
export type GetSubprojectBySlugQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetSubprojectBySlug<
  TData = Awaited<ReturnType<typeof getSubprojectBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojectBySlug>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubprojectBySlug>>,
          TError,
          Awaited<ReturnType<typeof getSubprojectBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubprojectBySlug<
  TData = Awaited<ReturnType<typeof getSubprojectBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojectBySlug>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubprojectBySlug>>,
          TError,
          Awaited<ReturnType<typeof getSubprojectBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubprojectBySlug<
  TData = Awaited<ReturnType<typeof getSubprojectBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojectBySlug>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSubprojectBySlug<
  TData = Awaited<ReturnType<typeof getSubprojectBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojectBySlug>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSubprojectBySlugQueryOptions(slug, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSubprojects = (params?: GetSubprojectsParams, signal?: AbortSignal) => {
  return clientAuthFetcher<SubprojectListResponse>({ url: `/api/subprojects`, method: 'GET', params, signal });
};

export const getGetSubprojectsQueryKey = (params?: GetSubprojectsParams) => {
  return [`/api/subprojects`, ...(params ? [params] : [])] as const;
};

export const getGetSubprojectsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojects>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetSubprojectsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojects>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubprojectsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubprojects>>> = ({ signal }) =>
    getSubprojects(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getSubprojects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSubprojectsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getSubprojects>>>;
export type GetSubprojectsInfiniteQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetSubprojectsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojects>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: undefined | GetSubprojectsParams,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojects>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubprojects>>,
          TError,
          Awaited<ReturnType<typeof getSubprojects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubprojectsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojects>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetSubprojectsParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojects>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubprojects>>,
          TError,
          Awaited<ReturnType<typeof getSubprojects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubprojectsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojects>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetSubprojectsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojects>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSubprojectsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojects>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetSubprojectsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojects>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSubprojectsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetSubprojectsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubprojects>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetSubprojectsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojects>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubprojectsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubprojects>>> = ({ signal }) =>
    getSubprojects(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubprojects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSubprojectsQueryResult = NonNullable<Awaited<ReturnType<typeof getSubprojects>>>;
export type GetSubprojectsQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetSubprojects<
  TData = Awaited<ReturnType<typeof getSubprojects>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: undefined | GetSubprojectsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojects>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubprojects>>,
          TError,
          Awaited<ReturnType<typeof getSubprojects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubprojects<
  TData = Awaited<ReturnType<typeof getSubprojects>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetSubprojectsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojects>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubprojects>>,
          TError,
          Awaited<ReturnType<typeof getSubprojects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubprojects<
  TData = Awaited<ReturnType<typeof getSubprojects>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetSubprojectsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojects>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSubprojects<
  TData = Awaited<ReturnType<typeof getSubprojects>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetSubprojectsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojects>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSubprojectsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSubprojectPhotos = (id: string, signal?: AbortSignal) => {
  return clientAuthFetcher<SubprojectPhotosResponse>({ url: `/api/subprojects/${id}/photos`, method: 'GET', signal });
};

export const getGetSubprojectPhotosQueryKey = (id: string) => {
  return [`/api/subprojects/${id}/photos`] as const;
};

export const getGetSubprojectPhotosInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojectPhotos>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojectPhotos>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubprojectPhotosQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubprojectPhotos>>> = ({ signal }) =>
    getSubprojectPhotos(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getSubprojectPhotos>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSubprojectPhotosInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getSubprojectPhotos>>>;
export type GetSubprojectPhotosInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetSubprojectPhotosInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojectPhotos>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojectPhotos>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubprojectPhotos>>,
          TError,
          Awaited<ReturnType<typeof getSubprojectPhotos>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubprojectPhotosInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojectPhotos>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojectPhotos>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubprojectPhotos>>,
          TError,
          Awaited<ReturnType<typeof getSubprojectPhotos>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubprojectPhotosInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojectPhotos>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojectPhotos>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSubprojectPhotosInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getSubprojectPhotos>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubprojectPhotos>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSubprojectPhotosInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetSubprojectPhotosQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubprojectPhotos>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojectPhotos>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubprojectPhotosQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubprojectPhotos>>> = ({ signal }) =>
    getSubprojectPhotos(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubprojectPhotos>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSubprojectPhotosQueryResult = NonNullable<Awaited<ReturnType<typeof getSubprojectPhotos>>>;
export type GetSubprojectPhotosQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetSubprojectPhotos<
  TData = Awaited<ReturnType<typeof getSubprojectPhotos>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojectPhotos>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubprojectPhotos>>,
          TError,
          Awaited<ReturnType<typeof getSubprojectPhotos>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubprojectPhotos<
  TData = Awaited<ReturnType<typeof getSubprojectPhotos>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojectPhotos>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubprojectPhotos>>,
          TError,
          Awaited<ReturnType<typeof getSubprojectPhotos>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubprojectPhotos<
  TData = Awaited<ReturnType<typeof getSubprojectPhotos>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojectPhotos>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSubprojectPhotos<
  TData = Awaited<ReturnType<typeof getSubprojectPhotos>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubprojectPhotos>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSubprojectPhotosQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getCategoryById = (id: string, signal?: AbortSignal) => {
  return clientAuthFetcher<CategoryDetailResponse>({ url: `/api/taxonomy/categories/${id}`, method: 'GET', signal });
};

export const getGetCategoryByIdQueryKey = (id: string) => {
  return [`/api/taxonomy/categories/${id}`] as const;
};

export const getGetCategoryByIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getCategoryById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategoryById>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCategoryByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoryById>>> = ({ signal }) =>
    getCategoryById(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCategoryById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCategoryByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCategoryById>>>;
export type GetCategoryByIdInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetCategoryByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCategoryById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategoryById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryById>>,
          TError,
          Awaited<ReturnType<typeof getCategoryById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategoryByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCategoryById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategoryById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryById>>,
          TError,
          Awaited<ReturnType<typeof getCategoryById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategoryByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCategoryById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategoryById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetCategoryByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCategoryById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategoryById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCategoryByIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetCategoryByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCategoryById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryById>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCategoryByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoryById>>> = ({ signal }) =>
    getCategoryById(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCategoryById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCategoryByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCategoryById>>>;
export type GetCategoryByIdQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetCategoryById<
  TData = Awaited<ReturnType<typeof getCategoryById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryById>>,
          TError,
          Awaited<ReturnType<typeof getCategoryById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategoryById<
  TData = Awaited<ReturnType<typeof getCategoryById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryById>>,
          TError,
          Awaited<ReturnType<typeof getCategoryById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategoryById<
  TData = Awaited<ReturnType<typeof getCategoryById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetCategoryById<
  TData = Awaited<ReturnType<typeof getCategoryById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCategoryByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getCategoryBySlug = (slug: string, signal?: AbortSignal) => {
  return clientAuthFetcher<CategoryDetailResponse>({
    url: `/api/taxonomy/categories/slug/${slug}`,
    method: 'GET',
    signal,
  });
};

export const getGetCategoryBySlugQueryKey = (slug: string) => {
  return [`/api/taxonomy/categories/slug/${slug}`] as const;
};

export const getGetCategoryBySlugInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getCategoryBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategoryBySlug>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCategoryBySlugQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoryBySlug>>> = ({ signal }) =>
    getCategoryBySlug(slug, signal);

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCategoryBySlug>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCategoryBySlugInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCategoryBySlug>>>;
export type GetCategoryBySlugInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetCategoryBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCategoryBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategoryBySlug>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryBySlug>>,
          TError,
          Awaited<ReturnType<typeof getCategoryBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategoryBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCategoryBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategoryBySlug>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryBySlug>>,
          TError,
          Awaited<ReturnType<typeof getCategoryBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategoryBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCategoryBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategoryBySlug>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetCategoryBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCategoryBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategoryBySlug>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCategoryBySlugInfiniteQueryOptions(slug, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetCategoryBySlugQueryOptions = <
  TData = Awaited<ReturnType<typeof getCategoryBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryBySlug>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCategoryBySlugQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoryBySlug>>> = ({ signal }) =>
    getCategoryBySlug(slug, signal);

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCategoryBySlug>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCategoryBySlugQueryResult = NonNullable<Awaited<ReturnType<typeof getCategoryBySlug>>>;
export type GetCategoryBySlugQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetCategoryBySlug<
  TData = Awaited<ReturnType<typeof getCategoryBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryBySlug>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryBySlug>>,
          TError,
          Awaited<ReturnType<typeof getCategoryBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategoryBySlug<
  TData = Awaited<ReturnType<typeof getCategoryBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryBySlug>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryBySlug>>,
          TError,
          Awaited<ReturnType<typeof getCategoryBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategoryBySlug<
  TData = Awaited<ReturnType<typeof getCategoryBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryBySlug>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetCategoryBySlug<
  TData = Awaited<ReturnType<typeof getCategoryBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryBySlug>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCategoryBySlugQueryOptions(slug, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getCategories = (params?: GetCategoriesParams, signal?: AbortSignal) => {
  return clientAuthFetcher<CategoryListResponse>({ url: `/api/taxonomy/categories`, method: 'GET', params, signal });
};

export const getGetCategoriesQueryKey = (params?: GetCategoriesParams) => {
  return [`/api/taxonomy/categories`, ...(params ? [params] : [])] as const;
};

export const getGetCategoriesInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getCategories>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetCategoriesParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCategoriesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategories>>> = ({ signal }) =>
    getCategories(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCategoriesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCategories>>>;
export type GetCategoriesInfiniteQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetCategoriesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCategories>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: undefined | GetCategoriesParams,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategories>>,
          TError,
          Awaited<ReturnType<typeof getCategories>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategoriesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCategories>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetCategoriesParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategories>>,
          TError,
          Awaited<ReturnType<typeof getCategories>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategoriesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCategories>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetCategoriesParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetCategoriesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCategories>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetCategoriesParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCategoriesInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCategories>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetCategoriesParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCategoriesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategories>>> = ({ signal }) =>
    getCategories(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getCategories>>>;
export type GetCategoriesQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetCategories<
  TData = Awaited<ReturnType<typeof getCategories>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: undefined | GetCategoriesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategories>>,
          TError,
          Awaited<ReturnType<typeof getCategories>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategories<
  TData = Awaited<ReturnType<typeof getCategories>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetCategoriesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategories>>,
          TError,
          Awaited<ReturnType<typeof getCategories>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategories<
  TData = Awaited<ReturnType<typeof getCategories>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetCategoriesParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetCategories<
  TData = Awaited<ReturnType<typeof getCategories>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetCategoriesParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategories>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCategoriesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopicById = (id: string, signal?: AbortSignal) => {
  return clientAuthFetcher<TopicDetailResponse>({ url: `/api/taxonomy/topics/${id}`, method: 'GET', signal });
};

export const getGetTopicByIdQueryKey = (id: string) => {
  return [`/api/taxonomy/topics/${id}`] as const;
};

export const getGetTopicByIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getTopicById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopicById>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTopicByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopicById>>> = ({ signal }) => getTopicById(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTopicById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTopicByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getTopicById>>>;
export type GetTopicByIdInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetTopicByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTopicById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopicById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopicById>>,
          TError,
          Awaited<ReturnType<typeof getTopicById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTopicByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTopicById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopicById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopicById>>,
          TError,
          Awaited<ReturnType<typeof getTopicById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTopicByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTopicById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopicById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTopicByIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTopicById>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopicById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTopicByIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetTopicByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopicById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicById>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTopicByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopicById>>> = ({ signal }) => getTopicById(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopicById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTopicByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getTopicById>>>;
export type GetTopicByIdQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetTopicById<
  TData = Awaited<ReturnType<typeof getTopicById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopicById>>,
          TError,
          Awaited<ReturnType<typeof getTopicById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTopicById<
  TData = Awaited<ReturnType<typeof getTopicById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopicById>>,
          TError,
          Awaited<ReturnType<typeof getTopicById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTopicById<
  TData = Awaited<ReturnType<typeof getTopicById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTopicById<
  TData = Awaited<ReturnType<typeof getTopicById>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicById>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTopicByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopicBySlug = (slug: string, signal?: AbortSignal) => {
  return clientAuthFetcher<TopicDetailResponse>({ url: `/api/taxonomy/topics/slug/${slug}`, method: 'GET', signal });
};

export const getGetTopicBySlugQueryKey = (slug: string) => {
  return [`/api/taxonomy/topics/slug/${slug}`] as const;
};

export const getGetTopicBySlugInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getTopicBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopicBySlug>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTopicBySlugQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopicBySlug>>> = ({ signal }) =>
    getTopicBySlug(slug, signal);

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTopicBySlug>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTopicBySlugInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getTopicBySlug>>>;
export type GetTopicBySlugInfiniteQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetTopicBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTopicBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopicBySlug>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopicBySlug>>,
          TError,
          Awaited<ReturnType<typeof getTopicBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTopicBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTopicBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopicBySlug>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopicBySlug>>,
          TError,
          Awaited<ReturnType<typeof getTopicBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTopicBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTopicBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopicBySlug>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTopicBySlugInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTopicBySlug>>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopicBySlug>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTopicBySlugInfiniteQueryOptions(slug, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetTopicBySlugQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopicBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicBySlug>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTopicBySlugQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopicBySlug>>> = ({ signal }) =>
    getTopicBySlug(slug, signal);

  return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopicBySlug>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTopicBySlugQueryResult = NonNullable<Awaited<ReturnType<typeof getTopicBySlug>>>;
export type GetTopicBySlugQueryError =
  | AccessDeniedExceptionResponse
  | NotFoundExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetTopicBySlug<
  TData = Awaited<ReturnType<typeof getTopicBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicBySlug>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopicBySlug>>,
          TError,
          Awaited<ReturnType<typeof getTopicBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTopicBySlug<
  TData = Awaited<ReturnType<typeof getTopicBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicBySlug>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopicBySlug>>,
          TError,
          Awaited<ReturnType<typeof getTopicBySlug>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTopicBySlug<
  TData = Awaited<ReturnType<typeof getTopicBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicBySlug>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTopicBySlug<
  TData = Awaited<ReturnType<typeof getTopicBySlug>>,
  TError = AccessDeniedExceptionResponse | NotFoundExceptionResponse | InternalServerErrorExceptionResponse,
>(
  slug: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicBySlug>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTopicBySlugQueryOptions(slug, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopics = (params?: GetTopicsParams, signal?: AbortSignal) => {
  return clientAuthFetcher<TopicListResponse>({ url: `/api/taxonomy/topics`, method: 'GET', params, signal });
};

export const getGetTopicsQueryKey = (params?: GetTopicsParams) => {
  return [`/api/taxonomy/topics`, ...(params ? [params] : [])] as const;
};

export const getGetTopicsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getTopics>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetTopicsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopics>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTopicsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopics>>> = ({ signal }) => getTopics(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getTopics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTopicsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getTopics>>>;
export type GetTopicsInfiniteQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetTopicsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTopics>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: undefined | GetTopicsParams,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopics>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getTopics>>, TError, Awaited<ReturnType<typeof getTopics>>>,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTopicsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTopics>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetTopicsParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopics>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopics>>,
          TError,
          Awaited<ReturnType<typeof getTopics>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTopicsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTopics>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetTopicsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopics>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTopicsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getTopics>>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetTopicsParams,
  options?: { query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopics>>, TError, TData>> },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTopicsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetTopicsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopics>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetTopicsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopics>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTopicsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopics>>> = ({ signal }) => getTopics(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTopicsQueryResult = NonNullable<Awaited<ReturnType<typeof getTopics>>>;
export type GetTopicsQueryError =
  | BadRequestExceptionResponse
  | AccessDeniedExceptionResponse
  | ApiRequestValidationExceptionResponse
  | InternalServerErrorExceptionResponse;

export function useGetTopics<
  TData = Awaited<ReturnType<typeof getTopics>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params: undefined | GetTopicsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopics>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getTopics>>, TError, Awaited<ReturnType<typeof getTopics>>>,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTopics<
  TData = Awaited<ReturnType<typeof getTopics>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetTopicsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopics>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopics>>,
          TError,
          Awaited<ReturnType<typeof getTopics>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTopics<
  TData = Awaited<ReturnType<typeof getTopics>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetTopicsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopics>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTopics<
  TData = Awaited<ReturnType<typeof getTopics>>,
  TError =
    | BadRequestExceptionResponse
    | AccessDeniedExceptionResponse
    | ApiRequestValidationExceptionResponse
    | InternalServerErrorExceptionResponse,
>(
  params?: GetTopicsParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopics>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTopicsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
